export const DEFAULT_STATE = [];

export default function (state = DEFAULT_STATE, action) {
    if (action.type === 'MinistryEmailActions.ON_EMAILVARIABLES') {
        return action.result;
    }
    return state;
}
